import { render, staticRenderFns } from "./TermOfUse.vue?vue&type=template&id=40833fee&scoped=true&"
import script from "./TermOfUse.vue?vue&type=script&lang=js&"
export * from "./TermOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TermOfUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40833fee",
  null
  
)

export default component.exports